<template>
  <div class="quick-add" :class="{ 'quick-add--collapsed': collapsed }">
    <div class="quick-add__header">Quick Add <i class="quick-add__collapse-toggle material-icons" @click="toggleCollapse">{{ collapseIcon }}</i></div>
    <div class="quick-add__types-container">
      <div
        class="quick-add__field"
        v-for="(inputType, key) in inputTypes"
        v-if="inputType.name !== 'Submit' && inputType.name !== 'Button'"
        @click="addField(fieldData(inputType, key))">
        <i class="quick-add__icon material-icons">{{ inputType.icon }}</i> {{ inputType.name }}
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';

  export default {
    data: () => {
      return {
        collapsed: false,
      };
    },

    computed: {
      ...mapState({
        inputTypes: state => state.field.inputTypes,
        fields: state => state.admin.field.fields,
      }),

      ...mapGetters('admin', [
        'activePage',
      ]),

      collapseIcon() {
        return this.collapsed ? 'add' : 'remove';
      },
    },

    methods: {
      ...mapActions('admin', [
        'addField',
      ]),

      fieldData(inputType, key) {
        return {
          parentId: this.activePage.id,
          data: { title: `${inputType.name} (${this.fields.length + 1})`, field_type: key },
        };
      },

      toggleCollapse() {
        this.collapsed = !this.collapsed;
      },
    },
  };
</script>
